var map = {
	"./2-fontane-pirotecniche.jpg": "b7e8",
	"./4-fontane-pirotecniche.jpg": "c73d",
	"./6-fontane-pirotecniche.jpg": "a3af",
	"./acrobata-performer.jpg": "8ddb",
	"./animazione-bimbi-classic.jpg": "1851",
	"./animazione-bimbi-gonfiabili-operatore.jpg": "38e7",
	"./animazione-bimbi-luna-park.jpg": "2aa9",
	"./animazione-bimbi-premium.jpg": "d688",
	"./animazione-gonfiabili-operatore.jpg": "0cc8",
	"./arpa-aperitivo.jpg": "1c55",
	"./arpa-cerimonia.jpg": "6dd4",
	"./cameriere-comico.jpg": "4fd9",
	"./cantante-leggera-cerimonia.jpg": "1358",
	"./cantante-lirica-cerimonia.jpg": "b592",
	"./caricaturista.jpg": "bf00",
	"./cassa-portatile.jpg": "bcf8",
	"./cerimoniere.jpg": "1092",
	"./chitarra-aperitivo.jpg": "31de",
	"./chitarra-cerimonia.jpg": "4f6a",
	"./doppio-impianto.jpg": "1761",
	"./drag-queen.jpg": "047c",
	"./duo-acustico-aperitivo.jpg": "4529",
	"./gioco-quiz.jpg": "f3a6",
	"./luci-disco.jpg": "c267",
	"./mago.jpg": "b85e",
	"./organo-cerimonia.jpg": "fea1",
	"./palloncini.jpg": "3abf",
	"./photoboot-classico.jpg": "8e6b",
	"./photoboot-telone.jpg": "05bf",
	"./piano-aperitivo.jpg": "c473",
	"./piano-cerimonia.jpg": "e7ed",
	"./sand-art-base.jpg": "f78a",
	"./sand-art-personalizzato.jpg": "1ced",
	"./sax-aperitivo.jpg": "1eb6",
	"./sax-cerimonia.jpg": "c0cf",
	"./sparabolle.jpg": "c4ba",
	"./specchio-magico.jpg": "9e82",
	"./telo-proiettore.jpg": "301d",
	"./violino-aperitivo.jpg": "a91e",
	"./violino-cerimonia.jpg": "ed25",
	"./violino-elettrico.jpg": "dfa0",
	"./violoncello-cerimonia.jpg": "b9f9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5c93";